import React from 'react';
import { motion } from 'framer-motion';
import { BookMarkedIcon, CreditCardIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage relative isolate overflow-hidden pb-16 pt-12 sm:pb-20 sm:pt-16" data-id="element-116" data-mp="12a0mbehn46w7">
      <div className="absolute right-0 top-0 -z-10 h-80 w-80 border-b border-l border-gold/25" data-id="element-117" data-mp="x9upzl0fdw7s" />
      <div className="mx-auto max-w-6xl px-4 text-center" data-id="element-118" data-mp="sb1e1x0sed9q">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/40 bg-petrolDark px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-gold" data-id="element-119" data-mp="s9gji7eh2ubv">
          <BookMarkedIcon className="h-4 w-4" data-id="element-120" data-mp="3j896f9neq5ny" /> Megapack Bibliotecología Listo™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.04] text-white sm:text-6xl md:text-7xl" data-id="element-121" data-mp="3o7vkflb27pxt">
          Del diagnóstico al servicio.<br data-id="element-122" data-mp="30fya5yn9d5yt" />
          <span className="text-gold" data-id="element-123" data-mp="358rc6erce077">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto my-4 max-w-2xl sm:my-6" data-id="element-124" data-mp="35aucbrm7l9pn">
          <img src={productImage} alt="Megapack Bibliotecología Listo: seis tomos y cuatro bonos para la biblioteca escolar" className="mx-auto w-full drop-shadow-[0_24px_40px_rgba(15,10,30,.45)]" data-id="element-125" data-mp="2hk84o1g49rg6" />
        </motion.div>

        <div className="flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-126" data-mp="nbbe31x26h6v">
          {['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'].map(item => <span key={item} className="rounded-full border border-lineDark bg-petrolDark px-3 py-2" data-id="element-127" data-mp="ia5fingpvzpf">
              {item}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-128" data-mp="1azkwdtv2cmt9">
          <Button onClick={scrollToPricing} arrow data-id="element-129" data-mp="1ayjhtfeu9i6s">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-130" data-mp="15zq5vrf79z8q">
          <span className="inline-flex items-center gap-1.5" data-id="element-131" data-mp="x14mju1wmg6w"><ShieldCheckIcon className="h-4 w-4 text-gold" data-id="element-132" data-mp="x0csinnygqiq" /> Garantía 7 días</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-133" data-mp="3lt73mli5bhrm"><LockIcon className="h-4 w-4 text-gold" data-id="element-134" data-mp="3lquhrx99on9a" /> Pago seguro</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-135" data-mp="3hpsdv34enn0z"><CreditCardIcon className="h-4 w-4 text-gold" data-id="element-136" data-mp="1x9kugm9v74h7" /> Mercado Pago</span>
        </div>

        <p className="mt-5 inline-flex items-center gap-2 text-xs font-semibold text-mutedDark" data-id="element-137" data-mp="21awd27ubmpfw">
          <ZapIcon className="h-4 w-4 text-gold" data-id="element-138" data-mp="269zk1xtv35qi" /> Para bibliotecarios escolares y docentes de Bibliotecología de toda Argentina
        </p>
      </div>
    </section>;
}